export default __webpack_public_path__ + "static/media/icon_r.168714f5.svg";